import { useSelector } from 'react-redux';
import { appSelectors } from '@features/app';

export function useCurrentLanguage() {
  return useSelector(appSelectors.language);
}
